module.exports = __webpack_public_path__ + "img/code-jquery-xl.fe817219.webp";